import { Link } from "react-router-dom";
import { TrendingUp, Target, ShieldCheck, Lock } from "lucide-react";

const cards = [
    {
        icon: TrendingUp,
        title: "Add income",
        body: "Generate more revenue from the surgeons, accounts, and cases you already support.",
        testId: "problem-card-add-income",
    },
    {
        icon: Target,
        title: "Own more of the opportunity",
        body: "You are already in the room when these products are used. Add the right lines and make that business yours.",
        testId: "problem-card-own-more",
    },
    {
        icon: ShieldCheck,
        title: "Defend your relationships",
        body: "Reduce the need for competing reps to enter your accounts by becoming the trusted resource for more of your surgeons' needs.",
        testId: "problem-card-defend",
    },
    {
        icon: Lock,
        title: "Private by design",
        body: "Your information is never publicly listed or blindly shared. You decide which opportunities and companies you want to explore.",
        testId: "problem-card-private",
    },
];

export default function ProblemSection() {
    return (
        <section
            id="for-reps"
            data-testid="problem-section"
            className="bg-[#FAFAFA] border-b border-slate-200 scroll-mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
                    <div className="lg:col-span-6">
                        <p className="eyebrow">For Reps</p>
                        <h2 className="font-display mt-4 text-3xl md:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.1]">
                            The best access is
                            <br />
                            <span className="text-slate-500">already in the room.</span>
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:pt-3 space-y-4">
                        <p className="text-base md:text-lg text-slate-600 leading-relaxed">
                            You spent years earning your surgeons&rsquo; trust. You know
                            their preferences, understand their facilities, and already
                            support the cases where complementary products are being
                            used.
                        </p>
                        <p className="text-base md:text-lg text-slate-900 font-medium leading-relaxed">
                            Why let another rep capture business inside relationships
                            you built?
                        </p>
                        <p className="text-base md:text-lg text-slate-600 leading-relaxed">
                            1099er connects you with product lines so you can earn
                            more from your existing relationships, bring greater
                            value to your surgeons, and defend the business you have
                            worked hard to build.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {cards.map((c) => {
                        const Icon = c.icon;
                        return (
                            <div
                                key={c.title}
                                data-testid={c.testId}
                                className="group bg-white border border-slate-200 rounded-2xl p-7 hover:-translate-y-1 hover:shadow-lg hover:shadow-slate-200/60 transition-all duration-300"
                            >
                                <div className="w-10 h-10 rounded-lg bg-slate-900 flex items-center justify-center">
                                    <Icon size={18} className="text-white" />
                                </div>
                                <h3 className="font-display mt-6 text-lg font-semibold text-slate-900">
                                    {c.title}
                                </h3>
                                <p className="mt-3 text-sm md:text-base text-slate-600 leading-relaxed">
                                    {c.body}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
